import script from "./Fymusic.vue?vue&type=script&lang=ts&setup=true"
export * from "./Fymusic.vue?vue&type=script&lang=ts&setup=true"

import "./Fymusic.vue?vue&type=style&index=0&id=770ef5ae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770ef5ae"]])

export default __exports__